/* eslint-disable class-methods-use-this */

// Types
import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';

export default class NoOpDAO extends ComparisonItemBasedProposalDAO implements ProposalDAOInterface {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new NoOpDAO(proposal, proposalElement);
  }

  protected getColorKeys(): string[] {
    return [];
  }

  protected build(): void {
    // no operation DAO
  }
}
